import { styled } from "@mui/material"
import { motion } from "framer-motion"

export const MotionDiv = styled(motion.div)(() => ({}))
